import { render, staticRenderFns } from "./sxfn.vue?vue&type=template&id=6635c06f&scoped=true&"
import script from "./sxfn.vue?vue&type=script&lang=js&"
export * from "./sxfn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6635c06f",
  null
  
)

export default component.exports